import React from 'react';
import type { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorSaveLayout } from '../../layout/ErrorSaveLayout';
import { useErrorReport } from '../hooks/useErrorReport';
import { EnhancedError } from './EnhancedError';
import { SimpleError } from './SimpleError';
import type { BFFHttpError } from '../../../bff-api/model/BFFHttpError';

export const EnhancedErrorLayout: FC<{
    error: BFFHttpError | Error;
    path: string;
}> = ({ error, path }) => {
    useErrorReport(error, path);

    return (
        <ErrorSaveLayout>
            <ErrorBoundary fallback={<SimpleError error={error} />}>
                <EnhancedError error={error} />
            </ErrorBoundary>
        </ErrorSaveLayout>
    );
};
